import Vue from 'vue'
import moment from 'moment'

Vue.filter('amountFormat', (value) => {
  value = value / 100
  return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ");
})

Vue.filter('amountFormatNormal', (value) => {
  return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ");
})

Vue.filter('countFormat', (value) => {
  if (value > 999) return value.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
  else return value
})

Vue.filter('momentFormat', (date) => {
  let utc = moment.utc(date).toDate();
  return moment(utc).local().format('DD.MM.YY HH:mm')
})

Vue.filter('totalOrdersFilter', (value) => {
  let lastNum = value.toString().substr(value.toString().length - 1, 1);
  if (lastNum == 0 || lastNum > 4) {
    return value.toString() + " заказов";
  } else if (lastNum < 5 && lastNum > 1) {
    return value.toString() + " заказа";
  } else if (lastNum == 1) {
    return value.toString() + " заказ";
  }
})

Vue.filter('summ', (value) => {
  value = (value / 100).toFixed(2);
  return value.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
})